import React from 'react';

const EditResultsForm = () => {
  return <div>EditResultsForm</div>;
};

export default EditResultsForm;
